export default __webpack_public_path__ + "static/media/circle-geometry.7d4e362f.png";